import React, { useEffect, useState, useContext } from 'react';
import UserContext from '../../components/User_Context.js';
import * as api from "../../api/apiConnector.js";

const JumpToFlowise = () => {
  const [status, setStatus] = useState('Reindirizzamento in corso...');
  const { currentUser } = useContext(UserContext);

  useEffect(() => {
    const performRedirect = async () => {
      try {
        // Fetch del token JWT usando sendMessage
        const data = await api.sendMessage("flowise-token", {
          user: currentUser(),
          body: {}
        });

        const jwt = data.jwt;

        if (!jwt) {
          throw new Error('JWT token not found in response');
        }

        // Creazione del form HTML
        const form = document.createElement('form');
        form.action = process.env.REACT_APP_FLOWISE_URL;
        form.method = 'POST';
        form.style.display = 'none';

        // Creazione del campo hidden per il JWT
        const jwtInput = document.createElement('input');
        jwtInput.type = 'hidden';
        jwtInput.name = 'jwt';
        jwtInput.value = jwt;

        // Aggiunta del campo al form
        form.appendChild(jwtInput);

        // Aggiunta del form al DOM
        document.body.appendChild(form);

        // Invio automatico del form
        form.submit();

      } catch (error) {
        console.error('Errore durante il reindirizzamento a Flowise:', error);
        setStatus('Errore durante il reindirizzamento. Riprova più tardi.');
      }
    };

    performRedirect();
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontSize: '18px',
      color: '#666'
    }}>
      {status}
    </div>
  );
};

export default JumpToFlowise;
